module.exports = __webpack_public_path__ + "static/media/hiturunk.45fa4440.jpg";